export default __webpack_public_path__ + "static/media/blueberry-cream-bun.87576343.png";